<template>
  <div class="container">


    <!-- <div >
      <el-radio-group v-model="tabPosition" style="margin-bottom: 20px" @change="handleTabChange" class="di">
        <el-radio-button label="2">网络整机</el-radio-button>
        <el-radio-button label="3">网络部件</el-radio-button>
        <el-radio-button label="4">服务器整机</el-radio-button>
        <el-radio-button label="5">服务器部件</el-radio-button>
        <el-radio-button label="6">按箱物资</el-radio-button>
        <el-radio-button label="7">线材</el-radio-button>
      </el-radio-group>
    </div> -->
    <div class="title-en">搜索条件</div>
    <el-card class="box-card">
      <div class="search-container">
        <el-form :inline="true" :model="searchForm" class="search-form" label-width="100px">
          <el-row :gutter="20">
            <!-- <el-col :span="6">
              <el-form-item label="结单时间">
                <el-date-picker v-model="searchForm.finishedTime" type="daterange" range-separator="-"
                  style="width: 100%" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                  @change="handleDateChange">
                </el-date-picker>
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item label="姓名">
                <el-input v-model="searchForm.username" placeholder="姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="IDC用户名">
                <el-input v-model="searchForm.keji_user_name" placeholder="科技用户名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="科技账号">
                <el-input v-model="searchForm.keji_account" placeholder="科技账号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="区域-园区">
                <el-select clearable v-model="searchForm.idc_name" placeholder="请选择" @focus="handleSelectFocus">
                  <el-option
                    v-for="(item, index) in campusOptions"
                    :key="index"
                    :label="Object.values(item)[0]"
                    :value="Object.values(item)[0]"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">

            <el-col :span="6">
              <el-form-item label="是否可用">
                <el-select clearable v-model.number="searchForm.enable" placeholder="是否可用">
                  <el-option label=是 value=1></el-option>
                  <el-option label=否 value=0></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="账号类型">
                <el-select clearable v-model.number="searchForm.account_type" placeholder="账号类型">
                  <el-option label="Xo 巡检专员" value=巡检专员></el-option>
                  <el-option label="Zo 巡检PMO" value=巡检PMO></el-option>
                  <el-option label="Fo 维保PMO" value=维保PMO></el-option>
                  <el-option label="lo Io 服务器故障专项" value=服务器故障专员></el-option>
                  <el-option label="Iw 资源交付专员" value=资源交付专员></el-option>
                  <el-option label="Re 资源池 IT现场运维" value=IT现场运维></el-option>
                  <el-option label="v 腾讯人员" value=腾讯人员></el-option>
                  <el-option label="鸿云 基础设施运维" value=基础设施运维></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="search-button">
                <el-button type="primary" @click="handleSearch">点击查询</el-button>
                <el-button @click="handleReset">重置</el-button>
                <el-button @click="debouncedExport">{{ exportButtonText }}</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <div class="title-en">人员详情</div>
    <el-card class="box-card">
      <div class="table-container">
        <div class="button-container">
          <el-button type="primary" @click="upgradeDcopsStaff">更新在库人员</el-button>
          <!-- <el-button @click="handleExport">审计派单</el-button> -->
          <el-button @click="openColumnsDialog">表头设置</el-button>
        </div>
        <el-table :data="faults" border stripe @selection-change="handleSelectionChange" ref="table"
          v-loading="loading">
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column v-for="(column, index) in visibleColumns" :key="index" :prop="column.prop"
            :label="column.label" :width="column.width" :align="column.align" :fixed="column.fixed">
            <template slot-scope="scope">
              <span v-if="column.prop === 'operation'">
                <el-button type="text" size="small" @click="handleViewDetail(scope.row)">查看详情</el-button>
              </span>
              <span v-else-if="column.prop === 'opTicketid'">
                <a v-if="scope.row.opTicketid" :href="`https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=${scope.row.opTicketid}&isHistory=1`
                  " target="_blank">{{ scope.row.opTicketid }}</a>
                <span v-else>{{ scope.row.opTicketid || '-' }}</span>
              </span>
              <span v-else-if="column.prop === 'PN'">
                <el-tooltip :content="scope.row.PN" placement="top"
                  :disabled="!scope.row.PN || scope.row.PN.length <= 8">
                  <span class="ellipsis-text">{{ scope.row.PN || '-' }}</span>
                </el-tooltip>
              </span>
              <el-tag v-else-if="column.prop === 'feedback_status'" :type="scope.row.feedback_status === '已完成'
                ? 'success'
                : scope.row.feedback_status === '处理中'
                  ? 'warning'
                  : scope.row.feedback_status === '待处理'
                    ? 'info'
                    : 'danger'
                " size="small">
                {{ scope.row.feedback_status || '-' }}
              </el-tag>
              <el-tag v-else-if="column.prop === 'time_out'" :type="scope.row.time_out === '已超时' ? 'danger' : 'success'"
                size="small">
                {{ scope.row.time_out || '-' }}
              </el-tag>
              <el-tag v-else-if="column.prop === 'enable'" :type="scope.row.enable === 1 ? 'success' : 'danger'"
                size="small">
                {{ scope.row.enable === 1 ? '是' : '否' }}
              </el-tag>
              <span v-else>{{ scope.row[column.prop] || '-' }}</span>
            </template>
          </el-table-column>
        </el-table>

        <el-dialog title="设置显示项" :visible.sync="showColumnsDialog" :append-to-body="true" width="400px"
          :close-on-click-modal="false" custom-class="columns-dialog" :modal-append-to-body="false"
          :destroy-on-close="true">
          <el-checkbox-group v-model="selectedColumns" class="checkbox-group">
            <el-checkbox v-for="column in columns" :key="column.prop" :label="column.prop" class="checkbox-item">
              {{ column.label }}
            </el-checkbox>
          </el-checkbox-group>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="selectAllColumns">全选</el-button>
            <el-button size="small" @click="restoreDefaultColumns">恢复默认</el-button>
            <el-button size="small" type="primary" @click="saveColumnsDialog">保存</el-button>
          </div>
        </el-dialog>

        <div class="pagination-container">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getDcopsList, UpdateDcopsList } from '@/api/staff';
import * as XLSX from 'xlsx';
import { debounce } from 'lodash';
import { getCampusList } from '@/api/operation';
export default {
  name: 'FaultList',
  data() {
    return {
      // tabPosition: 2,
      showColumnsDialog: false,
      // tabParamsMap: {
      //   '2': { query_OPtype: "out", query_AStype: "network", query_SAtype: "machine" },
      //   '3': { query_OPtype: "out", query_AStype: "network", query_SAtype: "part" },
      //   '4': { query_OPtype: "out", query_AStype: "server", query_SAtype: "machine" },
      //   '5': { query_OPtype: "out", query_AStype: "server", query_SAtype: "part" },
      //   '6': { query_OPtype: "out", query_AStype: null, query_SAtype: "box" },
      //   '7': { query_OPtype: "out", query_AStype: null, query_SAtype: "wire" }
      // },
      columns: [
        { prop: 'username', label: '姓名', width: 240 },
        { prop: 'keji_user_name', label: '科技用户名', width: 240 },
        { prop: 'keji_account', label: '科技账号', width: 240 },
        { prop: 'email', label: '邮箱', width: 240 },

        { prop: 'telephone', label: '手机', width: 240 },
        { prop: 'enable', label: '是否可用', width: 200 },
        { prop: 'position', label: '职位', width: 480 },
        // { prop: 'account_type', label: '账号类型', width: 240 },
        // { prop: 'operation', label: '操作', align: 'center', fixed: 'right', width: 100 } 

      ],
      selectedColumns: [
        'username',
        'keji_user_name',
        'keji_account',
        'email',
        'position',
        'telephone',
        'enable',
        // 'account_type',
        // 'operation'
      ],
      defaultSelectedColumns: [
        'username',
        'keji_user_name',
        'keji_account',
        'email',
        'position',
        'telephone',
        'enable',
        // 'account_type',
        // 'operation'  // 
      ],
      visibleColumns: [],
      selectedRows: [],
      faults: [],
      searchForm: {
        username: "",
        keji_user_name: "",
        keji_account: "",
        email: "",
        position: "",
        telephone: "",
        enable: 1,
        // account_type: "",
      },
      campusOptions: [], // 用于存储园区接口返回的数据
      hasLoaded: false, // 添加标志位防止重复加载
      category_level_4Options: {
        1: [
          { value: '网络设备现场操作', label: '网络设备现场操作' },
          { value: '布线工桯复检', label: '普布线工桯复检通' },
          { value: '机架线缆裁撤', label: '机架线缆裁撤' },
        ],
        2: [{ value: '网络设备现场操作', label: '网络设备现场操作' }],
        3: [{ value: '布线工桯复检', label: '布线工桯复检' }],
        4: [{ value: '机架线缆裁撤', label: '机架线缆裁撤' }],
      },
      // 删除未使用的computedCategoryOptions方法
      campusOptions: [
        { value: 'sh-lg', label: '上海-临港' },
        { value: 'sh-sy', label: '上海-书院' },
        { value: 'hz-dg', label: '杭州-东冠' },
      ],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false,
    };
  },
  created() {

    const now = new Date();
    const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
    const endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    // this.searchForm.finishedTime = [
    //   this.$moment(startDate).format('YYYY-MM-DD'),
    //   this.$moment(endDate).format('YYYY-MM-DD'),
    // ];
    // this.handleDateChange(this.searchForm.finishedTime);
    this.visibleColumns = this.columns.filter((column) =>
      this.selectedColumns.includes(column.prop)
    );
    // 初始化tab参数
    // const currentTabParams = this.tabParamsMap[this.tabPosition];
    // if (currentTabParams) {
    //   this.searchForm.query_OPtype = currentTabParams.query_OPtype;
    //   this.searchForm.query_AStype = currentTabParams.query_AStype;
    //   this.searchForm.query_SAtype = currentTabParams.query_SAtype;
    // }
    this.fetchFaultData();
    // 创建防抖后的导出函数
    this.debouncedExport = debounce(this.handleExport, 300);
  },
  methods: {
    //园区获取数据接口
    async getCampusData() {  
      try {
        const params = {
          spec_sign: 1,
        };
        const response = await getCampusList(params);
        if (response.data && response.data.code === 200) {
          this.campusOptions = response.data.data; 
          this.hasLoaded = true;
          //console.log("成功设置 campusOptions:", this.campusOptions)
        } else {
          console.warn("接口返回状态码不正确:", response.data?.code)
        }
      } catch (error) {
        console.error('获取园区数据失败:', error);
      }
    },
    // focus 事件处理园区获取数据
    handleSelectFocus() {
      if (!this.hasLoaded) {
        this.getCampusData();
      }
    },
    handleDateChange(val) {
      if (val) {
        this.searchForm.start_time = val[0];
        this.searchForm.end_time = val[1] + ' 23:59:59';
      } else {
        this.searchForm.start_time = startDate;
        this.searchForm.end_time = endDate;
      }
    },
    fetchFaultData() {
      this.loading = true;
      const params = {
        page: this.currentPage,
        size: this.pageSize,
        export_excel: "",
        // category_level: Number(this.tabPosition),
        ...this.searchForm,
      };
      // delete params.finishedTime;
      if (params.bill_weight === '') {
        params.bill_weight = null;
      }
      if (params.is_expired === '') {
        params.is_expired = null;
      }

      getDcopsList(params)
        .then((res) => {
          if (res.data.code === 200) {
            this.faults = res.data.data || [];
            this.total = res.data.total || 0;
          } else {
            this.$message.error(res.msg || '获取列表失败');
          }
          this.loading = false;
        })
        .catch((err) => {
          console.error(err);

          this.$message.error('获取列表失败');
          this.loading = false;
        });
    },
    handleSearch() {
      this.currentPage = 1;
      this.fetchFaultData();
    },
    handleReset() {
      this.searchForm = {
        username: "",
        keji_user_name: "",
        keji_account: "",
        email: "",
        position: "",
        telephone: "",
        enable: 1,
        // account_type: "",
      };

      this.currentPage = 1;
      this.fetchFaultData();
    },

    async upgradeDcopsStaff() {
      // 增加提示框确认
      this.$confirm('确定更新在库人员吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {

        if (this.loading) return;
        this.loading = true;
        try {
          const response = await UpdateDcopsList({});
          if (response && response.data && response.data.code === 200) {
            this.$message.success('更新成功');
          } else {
            this.$message.error(response.data.msg || '更新失败');
          }
        } catch (error) {
          console.error('更新错误:', error);
          this.$message.error('更新失败，请重试');
        } finally {
          this.loading = false;
        }
      }).catch(() => {
        this.$message.info('已取消');
      });
      return;
    },
    async handleExport() {
      if (this.exportLoading) return;
      this.exportLoading = true;

      try {
        if (this.selectedRows.length === 0) {
          // 导出全部数据
          const params = {
            ...Object.fromEntries(
              Object.entries(this.searchForm).filter(
                ([key, value]) =>
                  // value !== '' && value !== null && value !== undefined && key !== 'finishedTime'
                  value !== '' && value !== null && value !== undefined
              )
            ),
          };

          // 添加当前tab参数
          // const currentTabParams = this.tabParamsMap[this.tabPosition];
          // if (currentTabParams) {
          //   Object.assign(params, currentTabParams);
          // }
          if (this.searchForm.bill_weight === '') {
            params.bill_weight = null;
          }
          if (this.searchForm.is_expired === '') {
            params.is_expired = null;
          }
          params.export_excel = "1";

          // 正确等待API响应
          const response = await getDcopsList(params);

          if (response && response.data && response.data.code === 200) {
            const allData = response.data.data || [];

            if (allData.length === 0) {
              this.$message.warning('没有数据可导出');
              return;
            }

            // 处理并导出数据...
            const worksheetData = allData.map((row) => {
              const rowData = {};
              this.columns.forEach((column) => {
                if (column.prop !== 'operation') {
                  let value = row[column.prop];
                  if (column.prop === 'finished_time' && value) {
                    value = this.$moment(value).format('YYYY-MM-DD HH:mm:ss');
                  }
                  rowData[column.label] = value || '-';
                }
              });
              return rowData;
            });

            // 创建并导出Excel文件...
            // const sheetNames = {
            //   '2': '网络整机',
            //   '3': '网络部件', 
            //   '4': '服务器整机',
            //   '5': '服务器部件',
            //   '6': '按箱物资',
            //   '7': '线材'
            // };
            const sheetName = '科技在库人员';
            const worksheet = XLSX.utils.json_to_sheet(worksheetData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
            const timestamp = this.$moment().format('YYYYMMDDHHmmss');
            const filename = `科技在库人员_${timestamp}.xlsx`;
            XLSX.writeFile(workbook, filename);
            this.$message.success('导出成功');
          } else {
            this.$message.error(response.data.msg || '导出失败');
          }
        }
        // ...处理选中行导出的逻辑
      } catch (error) {
        console.error('导出错误:', error);
        this.$message.error('导出失败，请重试');
      } finally {
        this.exportLoading = false;
      }
    },
    openColumnsDialog() {
      this.showColumnsDialog = true;
    },
    saveColumnsDialog() {
      this.showColumnsDialog = false;
      this.visibleColumns = this.columns.filter((column) =>
        this.selectedColumns.includes(column.prop)
      );
    },
    selectAllColumns() {
      this.selectedColumns = this.columns.map((column) => column.prop);
    },
    restoreDefaultColumns() {
      this.selectedColumns = [...this.defaultSelectedColumns];
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchFaultData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchFaultData();
    },
    // handleTabChange() {
    //   this.currentPage = 1;
    //   // 根据当前tab设置对应的查询参数
    //   const currentTabParams = this.tabParamsMap[this.tabPosition];
    //   if (currentTabParams) {
    //     this.searchForm.query_OPtype = currentTabParams.query_OPtype;
    //     this.searchForm.query_AStype = currentTabParams.query_AStype;
    //     this.searchForm.query_SAtype = currentTabParams.query_SAtype;
    //   }
    //   this.fetchFaultData();
    // },
    handleViewDetail(row) {
      window.open(
        `https://dcops.fre.tencent-cloud.com/appManage/tickets/details?params=${row.opTicketid}`,
        '_blank'
      );
    },
  },
  computed: {
    exportButtonText() {
      return this.selectedRows.length > 0 ? `导出已选(${this.selectedRows.length})` : '导出全部';
    },
  },
};
</script>

<style scoped>
.container {
  padding: 20px;
  min-height: 500px;
  /* 确保容器有最小高度 */
}

/* .container {
  padding: 20px;
} */

.ellipsis-text {
  display: inline-block;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}

.search-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}

.search-form {
  width: 100%;
}

.search-button {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 10px;
}

/* 调整表单项间距 */
.el-form-item {
  margin-bottom: 18px;
  display: flex;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}

.box-card {
  margin-bottom: 20px;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
}

.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}

.columns-dialog {
  margin-top: 0 !important;
  position: absolute !important;
  margin-left: 0 !important;
  top: 100% !important;
  left: 0 !important;
  transform: none !important;
}

.el-dialog__wrapper.columns-dialog {
  position: absolute !important;
  overflow: visible !important;
}

.checkbox-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 10px;
  max-height: 300px;
  overflow-y: auto;
}

.checkbox-item {
  margin-right: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dialog-footer {
  text-align: right;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
}

.dialog-footer .el-button+.el-button {
  margin-left: 8px;
}

/* PO单号链接样式 */
::v-deep .el-table a {
  color: #409eff;
  text-decoration: none;
  font-weight: 500;
}

::v-deep .el-table a:hover {
  color: #66b1ff;
  text-decoration: underline;
  font-weight: 500;
}

/* 修改日期选择器宽度 */
::v-deep .el-date-editor.el-input__inner,
.el-date-editor--daterange.el-input__inner {
  width: 100% !important;
}

::v-deep .el-range-editor.el-input__inner {
  width: 100% !important;
}

::v-deep .el-date-editor .el-range-input {
  width: 66% !important;
}

::v-deep .el-range-editor--small .el-range-input {
  font-size: 12px !important;
}

/* 统一下拉框和输入框宽度 */
::v-deep .el-select,
.el-input {
  width: 100% !important;
}

::v-deep .el-form-item__content {
  width: calc(100% - 10px) !important;
}
</style>
